const GCS_PREFIX = 'https://storage.googleapis.com/ewink-lenses-images/';
const PROXY_PREFIX = '/gcs-images/';

export const toProxyUrl = (url) => {
  if (!url) return url;
  if (url.startsWith(GCS_PREFIX)) {
    return PROXY_PREFIX + url.slice(GCS_PREFIX.length);
  }
  return url;
};
